import { NotifiableError } from "@bugsnag/js";
import * as proto from "./PdfWorkerProto";
import { useI18n } from "vue-i18n";

type I18N = ReturnType<typeof useI18n>;
type Translator = I18N["t"];

export interface TranslatedError {
    error: NotifiableError;
    text: string;
}

export function toNotifiableError(e: any): NotifiableError {
    if (typeof e === "string") {
        return e;
    }
    if (!e) {
        return "null or undefined exception";
    }
    if (typeof e.name === "string" && typeof e.message === "string") {
        return e;
    }
    if (typeof e.errorClass === "string" && typeof e.errorMessage === "string") {
        return e;
    }
    return String(e);
}

/**
 * Convert any error into something BugSnag will like and a localized string we can
 * push into an error log.
 * 
 * @param e the error
 */
export function translateError(t: Translator, e: any): TranslatedError {
    if (typeof e === "string") {
        return { error: e, text: e };
    }
    if (!e) {
        const text = "null or undefined exception";
        return { error: text, text };
    }
    if (e.kind === proto.Exceptions.Encrypted) {
        return {
            text: t('error.encrypted', { fileName: e.fileName }).toString(),
            error: { name: 'proto.Exceptions.Encrypted', message: "The file is encrypted." }
        };
    }
    if (typeof e.name === "string" && typeof e.message === "string") {
        return { error: e, text: e.message };
    }
    if (typeof e.errorClass === "string" && typeof e.errorMessage === "string") {
        return { error: e, text: e.errorMessage };
    }
    const text = String(e);
    return { error: text, text };
}
